// Internal
export const id = 'Id';
export const points = 'Points';
export const vfm = 'Value for money';

// Specs
export const make = 'Make';
export const model = 'Model';
export const variant = 'Variant';
export const price = 'Price';
export const fuel = 'Fuel';
export const transmission = 'Transmission';
export const engineCapacity = 'Engine Capacity';
export const chargingSpeed = 'Charging Speed';
export const v2l = 'V2L';
export const v2v = 'V2V';
export const acChargingSpeed = 'AC Charging Speed';
export const batteryTechnology = 'Battery Technology';
export const kerbWeight = 'Kerb Weight';
export const power = 'Power';
export const torque = 'Torque';
export const mileage = 'Mileage';
export const bodyType = 'Body Type';
export const releaseDate = 'Release Date';
export const length = 'Length';
export const width = 'Width';
export const height = 'Height';
export const wheelbase = 'Wheelbase';
export const groundClearance = 'Ground Clearance';
export const turningRadius = 'Turning Radius';
export const bootSpace = 'Boot Space';
export const tyres = 'Tyres';
export const fuelTank = 'Fuel Tank';

// Exterior
export const projectorHeadLamps = 'Projector Head Lamps';
export const automaticHeadlightControl = 'Automatic Headlight Control';
export const fogLamps = 'Fog Lamps';
export const rainSensingWipers = 'Rain Sensing Wipers';
export const rearWiper = 'Rear Wiper*';
export const alloyWheels = 'Alloy Wheels';

// Interior
export const powerWindows = 'Power Windows';
export const headsUpDisplay = 'Head Up Display';
export const electFoldableMirrors = 'Elect. Foldable External Mirrors';
export const electAdjustableMirrors = 'Elect. Adjustable External Mirrors';
export const autoDimmingIrvm = 'Auto Dimming IRVM';
export const driverSeatAdjust = 'Driver Seat Adjust';
export const telescopicSteeringAdjust = 'Telescopic Steering Adjust*';
export const tiltSteeringAdjust = 'Tilt Steering Adjust';
export const cabinFilter = 'Cabin Filter';
export const ambientLight = 'Ambient Light*';
export const frontMapLamps = 'Front Map Lamps*';
export const rearReadingLamps = 'Rear Reading Lamps*';
export const frontArmrest = 'Front Armrest';
export const rearArmrest = 'Rear Armrest';
export const sunRoof = 'Sun Roof';
export const rearAcVents = 'Rear AC Vents';
export const trunkLight = 'Trunk Light';

// Comfort
export const speakers = 'Speakers';
export const androidPlay = 'Android Auto Apple CarPlay';
export const powerWindowsOneTouch = 'Power Windows One Touch';
export const powerWindowsRemote = 'Power Windows Remote';
export const rearSunshade = 'Rear Sunshade';
export const followMeHomeLights = 'FollowMe Home Lights';
export const wirelessCharging = 'Wireless Charging';
export const cooledGloveBox = 'Cooled Glove Box';
export const climateControl = 'Climate Control';
export const pushStart = 'Push Start';
export const remoteKeylessEntry = 'Remote Keyless Entry';
export const cruiseControl = 'Cruise Control';
export const ventilatedFrontSeats = 'Ventilated Front Seats';
export const steeringMountedControl = 'Steering Mounted Control';

// Safety
export const sideCurtainAirbags = 'Side Curtain Airbags';
export const frontSideAirbags = 'Front Side Airbags';
export const laneCamera = 'Lane Camera';
export const camera360 = '360 Camera';
export const dualHorn = 'Dual Horn';
export const frontSensors = 'Front Parking Sensors';
export const rearSensors = 'Rear Sensors';
export const adas = 'ADAS';
